(function () {
  'use strict';
  var VW = window.VW || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = VW.moneyFormat || 'R {{amount}}';
    cents = Math.round(Number(cents) || 0);
    function withDelims(n, decimals, thousands, decimal) {
      var fixed = (n / 100).toFixed(decimals);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals ? parts[0] + decimal + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_space_separator': return withDelims(cents, 2, ' ', ',');
        default: return withDelims(cents, 2, ',', '.');
      }
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  /* ---------- announcement bar ---------- */
  $$('[data-bar]').forEach(function (bar) {
    var msgs = $$('.bar__msg', bar); if (msgs.length < 2) return;
    var i = 0, ms = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
    setInterval(function () { msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on'); }, ms);
  });

  /* ---------- overlays (menu, drawer) ---------- */
  var lastFocus = null;
  function openPanel(panel, scrim) {
    lastFocus = document.activeElement;
    scrim.hidden = false;
    requestAnimationFrame(function () { panel.classList.add('is-open'); });
    panel.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var f = panel.querySelector('button, a, input'); if (f) f.focus({ preventScroll: true });
  }
  function closePanel(panel, scrim) {
    panel.classList.remove('is-open'); panel.setAttribute('aria-hidden', 'true');
    scrim.hidden = true; document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }

  var mnav = $('#MobileNav'), mscrim = $('[data-menu-scrim]'), burger = $('[data-menu-open]');
  if (mnav && mscrim && burger) {
    burger.addEventListener('click', function () { burger.setAttribute('aria-expanded', 'true'); openPanel(mnav, mscrim); });
    $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { burger.setAttribute('aria-expanded', 'false'); closePanel(mnav, mscrim); }); });
    mscrim.addEventListener('click', function () { burger.setAttribute('aria-expanded', 'false'); closePanel(mnav, mscrim); });
  }

  /* ---------- search ---------- */
  var search = $('[data-search]');
  $$('[data-search-open]').forEach(function (b) { b.addEventListener('click', function () { if (!search) return; search.hidden = !search.hidden; if (!search.hidden) { var i = search.querySelector('input[type=search]'); if (i) i.focus(); } }); });
  $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', function () { if (search) search.hidden = true; }); });

  /* ---------- age gate ---------- */
  var gate = $('#AgeGate');
  if (gate && !(window.Shopify && window.Shopify.designMode)) {
    var ok = false; try { ok = localStorage.getItem('vw-age') === 'yes'; } catch (e) {}
    if (!ok) { gate.hidden = false; document.documentElement.style.overflow = 'hidden'; var y = gate.querySelector('[data-age-yes]'); if (y) y.focus(); }
    gate.querySelector('[data-age-yes]').addEventListener('click', function () {
      try { localStorage.setItem('vw-age', 'yes'); } catch (e) {}
      gate.hidden = true; document.documentElement.style.overflow = '';
    });
    gate.querySelector('[data-age-no]').addEventListener('click', function () { gate.querySelector('[data-age-msg]').hidden = false; });
  }

  /* ---------- slideshow ---------- */
  $$('[data-slideshow]').forEach(function (show) {
    var slides = $$('[data-slide]', show), dots = $$('[data-dot]', show); if (slides.length < 2) return;
    var i = 0, timer = null, secs = parseInt(show.dataset.autoplay, 10) || 0;
    function go(n) {
      slides[i].classList.remove('is-on'); if (dots[i]) dots[i].classList.remove('is-on');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-on'); if (dots[i]) dots[i].classList.add('is-on');
    }
    function start() { if (secs > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) { stop(); timer = setInterval(function () { go(i + 1); }, secs * 1000); } }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.dot, 10)); start(); }); });
    show.addEventListener('mouseenter', stop); show.addEventListener('mouseleave', start);
    var x0 = null;
    show.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    show.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); start(); } x0 = null; });
    start();
  });

  /* ---------- product tabs ---------- */
  $$('[data-tabs]').forEach(function (sec) {
    var tabs = $$('[data-tab]', sec), panels = $$('[data-panel]', sec);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on); });
        panels.forEach(function (p) { p.hidden = p.dataset.panel !== t.dataset.tab; });
      });
    });
  });

  /* ---------- cart drawer ---------- */
  var drawer = $('#CartDrawer'), dscrim = $('[data-drawer-scrim]');
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
    $$('[data-cart-count-text]').forEach(function (el) { el.textContent = '(' + n + ')'; });
  }
  function renderCart(cart) {
    if (!drawer) return;
    setCount(cart.item_count);
    var ship = $('[data-ship]', drawer), lines = $('[data-cart-lines]', drawer), foot = $('[data-cart-foot]', drawer);
    var free = VW.freeShipping || 0;
    if (free > 0 && cart.item_count > 0) {
      var left = free - cart.total_price, pct = Math.min(100, Math.round(cart.total_price / free * 100));
      ship.innerHTML = (left > 0 ? 'You’re <b>' + formatMoney(left) + '</b> away from free shipping.' : '<b>You’ve unlocked free shipping.</b>') + '<div class="meter"><i style="width:' + pct + '%"></i></div>';
    } else { ship.innerHTML = ''; }
    if (!cart.items.length) {
      lines.innerHTML = '<p class="drawer__empty">Your cart is empty.</p>'; foot.hidden = true; return;
    }
    foot.hidden = false;
    $('[data-cart-total]', drawer).textContent = formatMoney(cart.total_price);
    lines.innerHTML = cart.items.map(function (it, idx) {
      var img = it.image ? '<img src="' + esc(it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200') + '" alt="" loading="lazy">' : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="dline__variant">' + esc(it.variant_title) + '</span>' : '';
      var price = it.original_line_price !== it.final_line_price ? '<s class="muted">' + formatMoney(it.original_line_price) + '</s><br>' + formatMoney(it.final_line_price) : formatMoney(it.final_line_price);
      return '<div class="dline"><a class="dline__img" href="' + esc(it.url) + '">' + img + '</a>' +
        '<div><a class="dline__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
        '<div class="qty"><button type="button" data-line="' + (idx + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button><span>' + it.quantity + '</span><button type="button" data-line="' + (idx + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div></div>' +
        '<div class="dline__end">' + price + '<button type="button" class="dline__rm" data-line="' + (idx + 1) + '" data-q="0">Remove</button></div></div>';
    }).join('');
  }
  function fetchCart() { return fetch((VW.routes && VW.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function openDrawer() { if (!drawer || !dscrim) return; fetchCart().then(renderCart); openPanel(drawer, dscrim); }
  function closeDrawer() { if (drawer && dscrim) closePanel(drawer, dscrim); }
  if (drawer && dscrim) {
    $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    dscrim.addEventListener('click', closeDrawer);
    if (VW.cartDrawer) $$('[data-cart-open]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); }); });
    drawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line]'); if (!b) return;
      b.disabled = true;
      fetch((VW.routes && VW.routes.change || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(b.dataset.line, 10), quantity: Math.max(0, parseInt(b.dataset.q, 10)) }) })
        .then(function (r) { return r.json(); }).then(renderCart).catch(function () { b.disabled = false; });
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.classList.contains('is-open')) closeDrawer();
    if (mnav && mnav.classList.contains('is-open')) closePanel(mnav, mscrim);
    if (search && !search.hidden) search.hidden = true;
  });

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target; if (!form.matches || !form.matches('form[data-ajax-cart]')) return;
    if (!VW.cartDrawer || !drawer) return; // fall back to normal submit
    e.preventDefault();
    var btn = form.querySelector('[type=submit]'); var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch((VW.routes && VW.routes.add || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { openDrawer(); })
      .catch(function (err) { alert((err && (err.description || err.message)) || 'Could not add this product. Please try again.'); })
      .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  });

  /* ---------- product page ---------- */
  var pform = $('[data-product-form]');
  if (pform) {
    // quantity
    $$('[data-qty]', pform).forEach(function (b) {
      b.addEventListener('click', function () { var i = b.parentElement.querySelector('input'); i.value = Math.max(1, (parseInt(i.value, 10) || 1) + parseInt(b.dataset.qty, 10)); });
    });
    // gallery thumbs -> scroll main
    var main = $('[data-gallery-main]'), thumbs = $$('[data-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var n = parseInt(t.dataset.thumb, 10), imgs = $$('[data-slide]', main);
        if (imgs[n]) main.scrollTo({ left: imgs[n].offsetLeft, behavior: 'smooth' });
        thumbs.forEach(function (x) { x.classList.toggle('is-on', x === t); });
      });
    });
    if (main && thumbs.length) {
      main.addEventListener('scroll', function () {
        var n = Math.round(main.scrollLeft / main.clientWidth);
        thumbs.forEach(function (x, k) { x.classList.toggle('is-on', k === n); });
      }, { passive: true });
    }
    // variants
    var vjson = $('[data-variants]', pform);
    if (vjson) {
      var variants = JSON.parse(vjson.textContent);
      var idInput = $('[data-variant-id]', pform), addBtn = $('[data-add-btn]', pform);
      var priceEl = $('[data-price]'), compareEl = $('[data-compare]'), saveEl = $('[data-save]'), stickyPrice = $('[data-sticky-price]');
      pform.addEventListener('change', function (e) {
        if (!e.target.matches('[data-option]')) return;
        var sel = [1, 2, 3].map(function (p) { var c = pform.querySelector('[data-option="' + p + '"]:checked'); return c ? c.value : null; });
        var v = variants.find(function (x) { return x.options.every(function (o, k) { return sel[k] === null || sel[k] === o; }); });
        if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
        idInput.value = v.id;
        addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
        if (compareEl) { var sale = v.compare_at_price && v.compare_at_price > v.price; compareEl.hidden = !sale; compareEl.textContent = sale ? formatMoney(v.compare_at_price) : ''; if (saveEl) { saveEl.hidden = !sale; if (sale) saveEl.textContent = 'Save ' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%'; } }
        if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
      });
    }
    // sticky add to cart
    var sticky = $('[data-sticky-atc]'), mainBtn = $('[data-add-btn]', pform);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(mainBtn);
      var sbtn = $('[data-sticky-add]', sticky);
      if (sbtn) sbtn.addEventListener('click', function () { if (pform.requestSubmit) pform.requestSubmit(mainBtn); else mainBtn.click(); });
    }
  }
})();
